import { StyleSheet } from 'aphrodite'

import navigation from './navigation'

export default {
  navigation: StyleSheet.create(navigation)
}



// WEBPACK FOOTER //
// ./src/components/Settings/Motd/partials/FileSystem/style/index.js